<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">Announcements</h3>
    </div>
  </div>
  <div class="p-4">
    <div class="container">
      <div class="form-group row">
        <div class="col-12">
          <form [formGroup]="adminForm" (submit)="submit()">
            <label>Announcement Title <span class="text-danger">*</span></label>
            <input type="text" id="title" placeholder="Enter Announcement Title" formControlName="announcementSubject"
                   class="form-control mb-3">
            <label>Announcement <span class="text-danger">*</span></label>
            <div class="NgxEditor__Wrapper">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" formControlName="announcementBody" [placeholder]="'Type here...'"></ngx-editor>
            </div>

            <label>Announcement Type <span class="text-danger">*</span></label>
            <section class="example-section mb-3">
              <mat-checkbox formControlName="emailAnnouncement" class="example-margin" (change)="checkType=false;">
                Email Announcement
              </mat-checkbox>
              <mat-checkbox formControlName="webAnnouncement" class="example-margin " (change)="checkType=false;">
                Website Announcement
              </mat-checkbox>
              <p class="text-danger" *ngIf="checkType"> Announcement type is required</p>
            </section>

            <label>Recepient Type <span class="text-danger">*</span></label>
            <mat-radio-group formControlName="businessOwnersOnly" aria-label="Select an option"
                             style="display: flex;" class="example-margin mb-3">
              <mat-radio-button [value]="true">Business Owner Only</mat-radio-button>
              <mat-radio-button [value]="false">Business Owner + Team Members</mat-radio-button>
            </mat-radio-group>
            <label>Language <span class="text-danger">*</span></label>
            
            <mat-radio-group formControlName="lang" aria-label="Select an option"
                             style="display: flex;" class="example-margin mb-3">
              <mat-radio-button [value]="'en'">English</mat-radio-button>
              <mat-radio-button [value]="'ar'">Arabic</mat-radio-button>
            </mat-radio-group>

            <label>Sales Filter <span class="text-danger">*</span></label>
            <div class="row">
              <div class="col-12 pb-2">
                <mat-radio-group (change)="salesConfirm=true" formControlName="salesComparison" aria-label="Select an option"
                                 style="display: flex;" class="example-margin">
                  <mat-radio-button value="lte">Sales less than</mat-radio-button>
                  <mat-radio-button value="gte">Sales more than</mat-radio-button>
                </mat-radio-group>
                <p style="color:red;" *ngIf="salesConfirm">This includes users with no sales</p>
              </div>
              <div class="col-12">
                <input type="number" id="salesAmount" placeholder="Sales Amount" formControlName="salesAmount"
                       class="form-control mb-3">
              </div>
            </div>

            <label>Business Status <span class="text-danger">*</span></label>
            <ul>
              <li>
                <mat-checkbox formControlName="businessStatusVerified" (change)="checkReq = false;">
                  Verified
                </mat-checkbox>
              </li>
              <li>
                <mat-checkbox formControlName="businessStatusUnverified" (change)="checkReq = false;">
                  Unverified
                </mat-checkbox>
              </li>
              <li>
                <mat-checkbox formControlName="businessStatusActive" (change)="checkReq = false;">
                  Active
                </mat-checkbox>
              </li>
              <li>
                <mat-checkbox formControlName="businessStatusInactive" (change)="checkReq = false;">
                  Inactive
                </mat-checkbox>
              </li>
              <li>
                <mat-checkbox formControlName="businessStatusBlocked" (change)="checkReq = false;">
                  Blocked
                </mat-checkbox>
              </li>
            </ul>
            <p class="text-danger" *ngIf="checkReq"> Business Status is Required</p>
            <div class="row justify-content-end">
              <div class="col-auto">
                <button class="btn btn-primary mr-2" type="submit" [disabled]="!adminForm.valid">Submit</button>
              </div>
            </div>
            <p *ngIf="totalEmails">Total users received the Announcement: <span class="text-success fw-bold">{{emails}}</span></p>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
